import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

/**
 * Public entry-point to the web app. Decides where to send the visitor:
 *   - already onboarded → /today (the in-app home)
 *   - has account but not onboarded → /welcome
 *   - everything else → /welcome (which routes them through onboarding)
 *
 * This is the URL the marketing site links to as "Open Web App".
 */
export default function AppEntry() {
  const { profile, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-[100dvh] grid place-items-center bg-background text-foreground">
        <div className="font-serif italic text-2xl text-brand animate-soft-pulse">sister signal</div>
      </div>
    );
  }
  let onboarded = profile?.onboarded;
  if (!onboarded) {
    try { onboarded = window.localStorage.getItem("ss_onboarded") === "1"; } catch { /* ignore */ }
  }
  return <Navigate to={onboarded ? "/today" : "/welcome"} replace />;
}
